import { useTranslation } from "next-i18next";
import { cn } from "../../../../../lib/utils";

const ASSETS_PATH = "/landings/assets/images/products/hub-talentos";

const logos = [
	{ name: "GP Cargo", file: "logo-gpcargo.svg", width: 265, height: 120 },
	{ name: "GAV", file: "logo-gav.svg", width: 402, height: 80 },
	{ name: "BR Com", file: "logo-brcom.svg", width: 375, height: 80 },
	{ name: "Zignet", file: "logo-zignet.svg", width: 263, height: 120 },
	{ name: "Mutant", file: "logo-mutant.svg", width: 540, height: 80 },
];

export default function EmpresasSection() {
	const { t } = useTranslation();

	return (
		<section className="bg-neutral-08 overflow-hidden">
			<div
				className={cn(
					"container-blog",
					"flex flex-col items-center",
					"gap-8",
					"tablet:gap-8",
					"laptop:gap-[56px]"
				)}
			>
				<h2
					className={cn(
						"text-vivid-02 m-0 mx-auto text-center",
						"text-[24px] leading-[32px]",
						"tablet:text-[24px] tablet:leading-[32px]",
						"laptop:text-[40px] laptop:leading-[48px]",
						"max-w-[567px]"
					)}
				>
					<span className="font-normal text-vivid-02">
						{t("products.hub-talentos.empresas.title")}
					</span>
					<br />
					<span className="font-semibold text-vivid-02">
						{t("products.hub-talentos.empresas.titleHighlight")}
					</span>
				</h2>

				{/* Logos marquee */}
				<div className="w-full overflow-hidden">
					<div
						className={cn(
							"flex items-center",
							"gap-10",
							"tablet:gap-12",
							"laptop:gap-[120px]",
							"animate-marquee"
						)}
						style={{
							width: "max-content",
						}}
					>
						{[...logos, ...logos].map((logo, i) => (
							<img
								key={`${logo.name}-${i}`}
								src={`${ASSETS_PATH}/${logo.file}`}
								alt={logo.name}
								className="h-auto object-contain shrink-0"
								style={{
									width: `${logo.width * 0.5}px`,
									height: `${logo.height * 0.5}px`,
								}}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
